module.exports = __webpack_public_path__ + "media/images/mypage/icon/green-pale/ico_home-8ed2b2c05a42df9e2d412321b2679102.svg";